import { Link, useLocation, useNavigate } from "react-router-dom"
import { useRef, useState } from "react";
import { handleError, useAuth } from "../../modules/authentication/AuthProvider";
import { Input, Button, Alert } from "react-daisyui";
import routes from "../../modules/routes/Routes";
import { AuthError } from "@supabase/supabase-js";
import AuthenticationScreen from "./AuthenticationScreen";
import { useTranslation } from 'react-i18next';

const Reset: React.FC = () => {
    const { resetPassword } = useAuth();
    const { t } = useTranslation();

    const passwordRef = useRef<HTMLInputElement>(null);
    const confirmPasswordRef = useRef<HTMLInputElement>(null);

    const [passwordError, setPasswordError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [resetSuccess, setResetSuccess] = useState<boolean>(false);

    const navigate = useNavigate();

    async function handleAuthError(error: AuthError) {
        const handledError = handleError(error);

        console.log({ error, authError: handledError })

        if (handledError) {
            setPasswordError(handledError.message);
        }
    }

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        setPasswordError(null);

        if (passwordRef.current && confirmPasswordRef.current) {
            if (passwordRef.current.value !== confirmPasswordRef.current.value) {
                setPasswordError("Passwords do not match");
                return;
            }

            setLoading(true);

            const { error } = await resetPassword(passwordRef.current.value);

            if (error !== null) {
                handleAuthError(error);
            } else {
                setResetSuccess(true);
            }
        }
        setLoading(false);
    }

    return (
        <AuthenticationScreen title="Reset Password">
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                <div className="flex flex-col gap-3">
                    {resetSuccess ? (
                        <Alert color="success">
                            Password reset successful. You can now log in with your new password.
                        </Alert>
                    ) : (
                        <>
                            <Input 
                                ref={passwordRef} 
                                type="password" 
                                placeholder="Enter new password"
                                color={passwordError !== null ? "error" : undefined} 
                                required 
                            />
                            <Input 
                                ref={confirmPasswordRef} 
                                type="password" 
                                placeholder="Confirm new password"
                                color={passwordError !== null ? "error" : undefined} 
                                required 
                            />
                            <Button type="submit" color="primary" disabled={loading}>
                                {loading ? "Resetting Password..." : "Reset Password"}
                            </Button>

                            {passwordError !== null && (
                                <Alert color="error">
                                    {passwordError}
                                </Alert>
                            )}
                        </>
                    )}

                    <p className="mt-3 text-sm">
                        Remember your password? <Link to={routes.authentication.login.build()} className="text-primary">Back to Login</Link>
                    </p>
                </div>
            </form>
        </AuthenticationScreen>
    );
}

export default Reset;